import { doc, getDoc } from "firebase/firestore";
import { initializeFSTORE } from "../Scripts/initializeFSTORE";
const DEFAULT_db = initializeFSTORE();

export const getProduct = async (db = DEFAULT_db, product_id) => {
    const docRef = doc(db, "products", product_id);
    let productDoc = await getDoc(docRef)
    if(productDoc.exists){
        return productDoc.data()
    } else {
        return null
    }
}